import {css} from "@pandacss/css";
import {createPandaComponent} from "../helpers/pandaComponent.ts";
import {font} from "../style/typography.tsx";

const backgroundClass = css({
    background: "neutral.900",
    color: "neutral.100",
    width: "100svw",
    minHeight: "100svh",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    gap: "20px"
})

export default createPandaComponent('Background', 'div', [backgroundClass, font("body", "1", "regular")]);